export enum FileTypes {
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV = 'text/csv;charset=utf-8',
}

export enum FileExtension {
  XLSX = 'xlsx',
  CSV = 'csv',
}
